import { makeVar } from "@apollo/client";

const themeVar = makeVar("light");

export default themeVar;
